import React from 'react';
import useSurfaceNodeInitialValuesFromServer from 'routes/surface/components/node-modal-form/hooks/use-surface-node-initial-values-from-server';
import { useTranslation } from 'i18n';
import Form from 'components/form';
import Button from 'components/button';
import {
  EditorWrapper,
  Header,
  SimpleBar,
} from 'routes/surface/components/node-modal-form/style';
import { NameInput, ReadOnlyMessage, Info } from './style';
import { withModal } from 'hoc';
import { set, flow, omit } from 'lodash/fp';
import { ModalContext } from 'hoc/with-modal';
import { NodeModalInput } from 'types';
import { SurfaceTextNode } from 'graphql/types';

export interface TextSnippetNodeModalContentProps {
  data: NodeModalInput<SurfaceTextNode>;
  modal: ModalContext;
}

function TextSnippetNodeModalContent(props: TextSnippetNodeModalContentProps) {
  const { initialValues: data } = useSurfaceNodeInitialValuesFromServer(
    props.data,
  );
  const { t } = useTranslation();

  const initialValues = flow(
    set('slateData', { data: data.slateData, text: data.text }),
    omit(['text']),
  )(data);

  return (
    <>
      <Header>
        <Button label={t('Close')} onClick={props.modal.hide} secondary />
        <ReadOnlyMessage>
          <Info />
          {t('Read only')}
        </ReadOnlyMessage>
      </Header>
      <EditorWrapper>
        <NameInput value={initialValues.name} disabled />
        <SimpleBar>
          <Form initialValues={initialValues} onSubmit={() => undefined}>
            <Form.TextEditor readOnly name="slateData" />
          </Form>
        </SimpleBar>
      </EditorWrapper>
    </>
  );
}

export default withModal(TextSnippetNodeModalContent);
